import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { label: "Mission", href: "#mission" },
  { label: "Kits", href: "#kits" },
  { label: "Impact", href: "#impact" },
  { label: "Programs", href: "#programs" },
  { label: "Gallery", href: "#gallery" },
  { label: "Partner", href: "#partner" },
  { label: "Get Involved", href: "#involved" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b hairline py-3" : "bg-transparent py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); go("#top"); }} data-testid="logo-link" className="flex items-center gap-3">
          <img src="/amcares-logo-transparent.png" alt="AMCares Foundation" className="h-16 md:h-[4.5rem] w-auto" />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-brand-ink/70 hover:text-brand-blue transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-donate-btn"
            onClick={() => go("#involved")}
            className="bg-brand-blue text-white hover:bg-brand-bluedark transition-colors duration-300 rounded-full px-6 py-2.5 text-sm font-semibold"
          >
            Donate a Kit
          </button>
        </div>

        <button data-testid="mobile-menu-btn" className="lg:hidden text-brand-ink" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t hairline overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <button key={l.href} onClick={() => go(l.href)} className="text-left text-base font-medium text-brand-ink/80">
                  {l.label}
                </button>
              ))}
              <button onClick={() => go("#involved")} className="bg-brand-blue text-white rounded-full px-6 py-3 text-sm font-semibold">
                Donate a Kit
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
